(() => {
  const selector = '[data-orlisse-discovery-slider]';
  const init = (root) => {
    if (!root || root.dataset.sliderReady === 'true') return true;
    const Swiper = window.MinimogLibs && window.MinimogLibs.Swiper;
    if (!Swiper) return false;
    root.dataset.sliderReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    new Swiper(root, {
      slidesPerView: 1.36,
      spaceBetween: 14,
      speed: 650,
      loop: true,
      grabCursor: true,
      watchOverflow: true,
      autoplay: reducedMotion ? false : { delay: 3600, disableOnInteraction: false, pauseOnMouseEnter: true },
      pagination: { el: root.querySelector('.orlisse-merch-pagination'), clickable: true },
      breakpoints: {
        560: { slidesPerView: 2.2, spaceBetween: 16 },
        768: { slidesPerView: 3.15, spaceBetween: 18 },
        1100: { slidesPerView: 4, spaceBetween: 20 }
      }
    });
    return true;
  };
  const boot = () => {
    let attempts = 0;
    const retry = () => {
      attempts += 1;
      const pending = [...document.querySelectorAll(selector)].some((root) => !init(root));
      if (pending && attempts < 80) window.setTimeout(retry, 100);
    };
    retry();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll(selector).forEach(init));
})();
